import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'
import { type Campaign } from 'entities/Campaign'
import { useCampaignDetailContext } from 'pages/campaigns/ui/detail/CampaignDetail/context/context'
import { CampaignOverviewStore } from './store/CampaignOverviewStore'
import { CampaignOverviewContext } from './context/context'
import { CampaignOverviewUi } from './ui/CampaignOverviewUi'

type ICampaignOverviewProps = {
  campaign: Campaign
}

export const CampaignOverview = observer(({ campaign }: ICampaignOverviewProps) => {
  const { entities } = useCampaignDetailContext()
  const overviewTableStore = useMemo(
    () => new CampaignOverviewStore(campaign, entities),
    [campaign]
  )

  useEffect(() => {
    return overviewTableStore.dispose
  }, [])
  return (
    <CampaignOverviewContext.Provider value={overviewTableStore}>
      <CampaignOverviewUi />
    </CampaignOverviewContext.Provider>
  )
})
